var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessageCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.6717 22 9.4015 21.7405 8.23921 21.2684C8.13423 21.2258 8.07362 21.2013 8.02887 21.1845C8.02358 21.1825 8.01898 21.1808 8.01505 21.1794L8.0103 21.18C7.97339 21.185 7.92309 21.1933 7.82705 21.2093L4.24049 21.8071C4.07985 21.8339 3.90013 21.8639 3.74404 21.8757C3.57386 21.8885 3.30312 21.893 3.017 21.7703C2.6633 21.6186 2.38144 21.3367 2.22973 20.983C2.10701 20.6969 2.11148 20.4261 2.12433 20.256C2.13611 20.0999 2.16612 19.9202 2.19294 19.7596C2.19455 19.7499 2.19615 19.7403 2.19773 19.7308L2.79071 16.173C2.80672 16.0769 2.815 16.0266 2.82 15.9897L2.82063 15.9849C2.8192 15.981 2.81751 15.9764 2.81552 15.9711C2.79872 15.9264 2.77419 15.8658 2.73156 15.7608C2.25952 14.5985 2 13.3283 2 12Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MessageCircle.f22ae3b9981f8917cc09e1265e721bde.svg";